/*
   Credit bar, shown only on home page and journey selection
 */

import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {} from '../../selectors/journeyState-selectors'
import '../../css/CreditNavBar.css'

import DebugButton from './DebugButton'

// set journey
// set nav
// set artwork

const CreditNavBar = props => (
   <div className={'credit-nav-bar'}>
      {process.env.NODE_ENV === 'development' && <DebugButton />}
      {/*<button className={'medium-1 credit-button'} >CREDIT</button>*/}
   </div>
)

const mapStateToProps = (state, ownProps) => ({...ownProps})
const mapDispatchToProps = dispatch => bindActionCreators({
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreditNavBar) 


// WEBPACK FOOTER //
// ./src/components/JourneyHome/CreditNavBar.js